import {
  BrandConfigurationSchema,
  BrandConfigurationSnapshot,
} from './interfaces';

export const validateBrandConfig = (brandConfig: BrandConfigurationSnapshot) =>
  BrandConfigurationSchema.parse(brandConfig);
